export const post = {
  slug: "founder-logs-day-75-ethos",
  title: "Founder Logs Day 75 - Ethos: ExoHaven Community Resilience",
  contentType: "article",
  excerpt:
    "ExoHaven Community Resilience Ethos: Visibility over violence, solidarity not escalation, peace as a feature.",
  categories: ["exoHaven", "Founder Logs", "Ethos"],
  tags: ["exoHaven", "exoWorld", "resilience", "community", "ethos"],
  author: {
    name: "E. x .O. Team",
    email: "team@exohaven.online",
  },
  publishedAt: "2026-01-16",
  status: "published",
  isTemplate: false,
  featuredImage: "",
  content: `# Founder Logs Day 75 - Ethos
ExoHaven Community Resilience Ethos

## What We Believe
ExoHaven is built on a simple truth: no one thrives alone. In uncertain times, our greatest strength isn't in confrontation—it's in connection, mutual support, and peaceful presence.

## We Prepare Together—Not for War, but for Community Survival
- Our tools—mesh networks, offline-first apps, local sync—are made to keep us connected, not to fight.
- We're here to help each other stay safe, warm, and informed, even when big systems break down.
- We know that when communities show up for each other, with calm and in numbers, the world changes.

## Visibility Over Violence
- We believe in the power of being seen: peacefully, together, watching out for each other.
- Our presence and our records (photos, receipts, shared logs) are our shield—not our fists.
- When we stand together, authorities are held accountable not by fear, but by community.

## Solidarity, Not Escalation
- We do not provoke, we do not escalate—we bear witness and show up for one another.
- Resistance doesn't mean conflict; it means refusing to let anyone stand alone, or be disappeared in the dark.
- The best "defense" is a neighbor who checks in, a group chat that's always live, a system that works even if the power's out.

## Peace Is a Feature
- Our resilience is not a strategy for war, but for peace.
- We are not "arming" civilians; we are preparing them—with skills, tools, and a community that has their back.
- In every crisis, the people who keep their heads and support each other get through it together.

## Faith, Dignity, and Hope
- We believe that every person is worthy of dignity, support, and hope—no matter what authorities or circumstances arise.
- If anyone faces arrest or injustice, we remember: God is on the side of the just, the peaceful, and the united.
- We prepare so no one has to be alone—and so there are always receipts, always witnesses, always a way back to community.

> "Resilience is not about fighting.
> It's about showing up, staying connected, and making sure nobody gets left behind."

This is ExoHaven.
This is how we thrive—together.

Lead us not in to temptation, but deliver us from evil. 
Amen. 

Resilience isn't the same as resistance—it's about care, not war.
God is on the side of the just, the peaceful, and the united.

Don't let provocation let you forget that, 
even in your darkest hour.`.trim(),
};

export default post;
